// Kalender libur bursa BEI/IDX (SKB & Peng-00171/BEI.POP/09-2025).
// Format: "YYYY-MM-DD". IDX juga tutup setiap Sabtu & Minggu.
export const IDX_HOLIDAYS = new Set([
  // 2026
  "2026-01-01", "2026-01-16",
  "2026-02-16", "2026-02-17",
  "2026-03-18", "2026-03-19", "2026-03-20", "2026-03-23", "2026-03-24",
  "2026-04-03",
  "2026-05-01", "2026-05-14", "2026-05-15", "2026-05-27", "2026-05-28",
  "2026-06-01", "2026-06-16",
  "2026-08-17", "2026-08-25",
  "2026-12-24", "2026-12-25", "2026-12-31",
]);

export const ymd = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

// d: Date yang mewakili tanggal WIB
export function isTradingDay(d) {
  const day = d.getDay(); // 0 Minggu, 6 Sabtu
  if (day === 0 || day === 6) return false;
  if (IDX_HOLIDAYS.has(ymd(d))) return false;
  return true;
}

export const isMarketClosedToday = (wib) => !isTradingDay(wib);

// Waktu briefing berikutnya (08:30 WIB pada hari bursa terdekat)
export function nextBriefingDate(wib) {
  const cand = new Date(wib);
  cand.setHours(8, 30, 0, 0);
  if (wib >= cand) cand.setDate(cand.getDate() + 1);
  let guard = 0;
  while (!isTradingDay(cand) && guard < 400) {
    cand.setDate(cand.getDate() + 1);
    guard++;
  }
  return cand;
}

const DAY_NAMES = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
export const dayNameId = (d) => DAY_NAMES[d.getDay()];

// Label kapan briefing berikutnya, relatif terhadap sekarang
export function nextBriefingLabel(wib, next) {
  const today = ymd(wib);
  const tomorrow = new Date(wib);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const nd = ymd(next);
  if (nd === today) return "hari ini 08:30 WIB";
  if (nd === ymd(tomorrow)) return "besok 08:30 WIB";
  return `${dayNameId(next)} 08:30 WIB`;
}
